import React from "react";

// This is a hard-coded value to match the incorrect math in _header.scss
export const HEADER_SPACE = "2px";
// -1rem is used to "undo" the padding from .site-content class.
export const SITE_CONTENT = "1rem";
export const MARGIN = `calc(-${SITE_CONTENT} - ${HEADER_SPACE})`;
// TODO: Clean this manual spacing up when the Header is refactored.

const Page = props => <main {...props} style={{ marginTop: MARGIN }} />;

export default Page;
